export function systemRender() { return `<div class="systemCont">
 <div class="system" style="${ this.__$objToStyleMap(this.style) }">
  <div class="system-icon" style="${ this.__$objToStyleMap(this.iconstyle) }">
  </div>
  <div class="text">${ this.messageText }</div>
 </div>
</div>` }